module.exports = __webpack_public_path__ + "static/alrightLogo-white-ae4d2033b5d40adf2dcc82eaa059d724.svg";